import type { VirtualTourNode } from '@indutrust/factory-model';
import type { Observable } from 'rxjs';
import { forkJoin, map, of } from 'rxjs';
import type { VrLinkApiClient } from '../vr-link-api-client.service';
import type { VrMarkerApiClient } from '../vr-marker-api-client.service';

type VirtualTourNodeSeed = Omit<VirtualTourNode, 'links' | 'markers'>;

function enrichNodeWithLinksAndMarkers(
  node: VirtualTourNodeSeed,
  links: VrLinkApiClient,
  markers: VrMarkerApiClient
): Observable<VirtualTourNode> {
  return forkJoin({
    links: links.getAll({ nodeId: node.id }),
    markers: markers.getAll({ nodeId: node.id }),
  }).pipe(
    map(({ links: nodeLinks, markers: nodeMarkers }) => ({
      ...node,
      links: nodeLinks,
      markers: nodeMarkers,
    }))
  );
}

/** Loads the full virtual-tour graph (nodes + links + markers) for a factory. */
export function loadVirtualTourGraph(
  nodeList: VirtualTourNodeSeed[],
  links: VrLinkApiClient,
  markers: VrMarkerApiClient
): Observable<VirtualTourNode[]> {
  if (nodeList.length === 0) {
    return of([]);
  }
  return forkJoin(
    nodeList.map((node) => enrichNodeWithLinksAndMarkers(node, links, markers))
  );
}
